import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'

import { Href } from 'components/navigation'
import { Image, Text } from 'components/dataDisplay'

import s from './ServiceCard.scss'


interface ServiceCardProps {
  className?: string
  title: string
  image: string
  to: string
}

const ServiceCard: React.FunctionComponent<ServiceCardProps> = (props) => {
  const { className, title, image, to } = props

  const { isTablet, isMobile } = useDevice()

  return (
    <Href className={className} to={to}>
      <div className={cx(s.card, s.gradientBackground, 'flex justify-center radius-16 overflow-hidden')}>
        <Image
          className={s.image}
          src={image}
          alt={title}
          height={isMobile ? '128' : isTablet ? '163' : '131'}
        />
      </div>
      <Text
        className="mt-16px text-center"
        message={title}
        size="c16"
      />
    </Href>
  )
}

export default ServiceCard